"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastMileDeliveryMixin = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _userLogs = require("@/mixins/user-logs/user-logs");

var _route = require("@/api/route.api");

var _lastMileDelivery = require("@/api/last-mile-delivery.api");

var _socket = require("@/api/socket.api");

var _plan = require("@/api/plan.api");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_TRUCK_WORKING_HOURS = [process.env.VUE_APP_DEFAULT_START_WORKINGHR, process.env.VUE_APP_DEFAULT_END_WORKINGHR];

var LastMileDeliveryMixin = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LastMileDeliveryMixin, _Mixins);

  var _super = _createSuper(LastMileDeliveryMixin);

  function LastMileDeliveryMixin() {
    var _this;

    (0, _classCallCheck2.default)(this, LastMileDeliveryMixin);
    _this = _super.apply(this, arguments);
    _this.disableTruckKey = process.env.VUE_APP_DISABLE_TRUCK_KEY;
    _this.disableTruckList = [];
    return _this;
  } // srtSeconds: number = 0;
  // endSeconds: number = 0;


  (0, _createClass2.default)(LastMileDeliveryMixin, [{
    key: "$socketId",
    get: function get() {
      return this.$store.getters['common/socketId'];
    },
    set: function set(newVal) {
      this.$setSocketId(newVal);
    }
  }, {
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "isSomeOrdersAssigned",
    get: function get() {
      if (this.$plan && this.$plan.trucks && this.$plan.trucks.length > 0) {
        return this.$plan.trucks.some(function (truck) {
          return truck.routes.some(function (route) {
            return route.status.toUpperCase() === 'ASSIGNED' || route.status.toUpperCase() === 'COMPLETED';
          });
        });
      }

      return false;
    }
  }, {
    key: "truckPlanIds",
    get: function get() {
      var truck = this.getTruckInPlan(this.$selectedTruck);

      if (this.$selectedTruck && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "$trucks",
    get: function get() {
      return this.$store.getters['lastMileDelivery/trucks'];
    },
    set: function set(newVal) {
      this.$setTrucks(newVal);
    }
  }, {
    key: "$bufferTrucks",
    get: function get() {
      return this.$store.getters['lastMileDelivery/bufferTrucks'];
    },
    set: function set(newVal) {
      this.$setBufferTrucks(newVal);
    }
  }, {
    key: "$GLOBAL_ACTIVE_USERS",
    get: function get() {
      return this.$store.getters['lastMileDelivery/GLOBAL_ACTIVE_USERS'];
    },
    set: function set(newVal) {
      this.$setGlobalActiveUsers(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_ORDERS",
    get: function get() {
      return this.$store.getters['lastMileDelivery/GLOBAL_SELECTED_ORDERS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedOrders(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_TRUCKS",
    get: function get() {
      return this.$store.getters['lastMileDelivery/GLOBAL_SELECTED_TRUCKS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedTrucks(newVal);
    }
  }, {
    key: "$failedOrders",
    get: function get() {
      return this.$store.getters['lastMileDelivery/failedOrders'];
    },
    set: function set(newVal) {
      this.$setFailedOrders(newVal);
    }
  }, {
    key: "$orderColumnTemplates",
    get: function get() {
      return this.$store.getters['lastMileDelivery/orderColumnTemplates'];
    },
    set: function set(newVal) {
      this.$setOrderColumnTemplates(newVal);
    }
  }, {
    key: "isManualAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileDelivery/isManualAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsManualAssignLoading(newVal);
    }
  }, {
    key: "isAutoAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileDelivery/isAutoAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsAutoAssignLoading(newVal);
    }
  }, {
    key: "$isAssignedDriverChanges",
    get: function get() {
      return this.$store.getters['lastMileDelivery/isAssignedDriverChanges'];
    },
    set: function set(newVal) {
      this.$setIsAssignedDriverChanges(newVal);
    }
  }, {
    key: "$toBeUnassignedOrderIds",
    get: function get() {
      return this.$store.getters['lastMileDelivery/toBeUnassignedOrderIds'];
    },
    set: function set(newVal) {
      this.$setToBeUnassignedOrderIds(newVal);
    }
  }, {
    key: "$dateRangeOption",
    get: function get() {
      return this.$store.getters['lastMileDelivery/dateRangeOption'];
    },
    set: function set(newVal) {
      this.$setDateRangeOption(newVal);
    }
  }, {
    key: "$pagination",
    get: function get() {
      return this.$store.getters['lastMileDelivery/pagination'];
    },
    set: function set(newVal) {
      this.$setPagination(newVal);
    }
  }, {
    key: "$dateRange",
    get: function get() {
      return [this.$startDate, this.$endDate];
    },
    set: function set(newVal) {
      if (newVal) {
        this.$setDateRange({
          startDate: newVal[0],
          endDate: newVal[1]
        });
      }
    }
  }, {
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDelivery/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "$truckLoading",
    get: function get() {
      return this.$store.getters['lastMileDelivery/truckLoading'];
    },
    set: function set(newVal) {
      this.$setTruckLoading(newVal);
    }
  }, {
    key: "$locationType",
    get: function get() {
      return this.$store.getters['lastMileDelivery/locationType'];
    },
    set: function set(newVal) {
      this.$setLocationType(newVal);
    }
  }, {
    key: "$searchType",
    get: function get() {
      return this.$store.getters['lastMileDelivery/searchType'];
    },
    set: function set(newVal) {
      this.$setSearchType(newVal);
    }
  }, {
    key: "$selectedTruck",
    get: function get() {
      return this.$store.getters['lastMileDelivery/selectedTruck'];
    },
    set: function set(newVal) {
      this.$setSelectedTruck(newVal);
    }
  }, {
    key: "$selectedLocation",
    get: function get() {
      return this.$store.getters['lastMileDelivery/selectedLocation'];
    },
    set: function set(newVal) {
      this.$setSelectedLocation(newVal);
    }
  }, {
    key: "$unassignedOrders",
    get: function get() {
      return this.$store.getters['lastMileDelivery/unassignedOrders'];
    },
    set: function set(newVal) {
      this.$setUnassignedOrders(newVal);
    }
  }, {
    key: "$excludedOrders",
    get: function get() {
      return this.$store.getters['lastMileDelivery/excludedOrders'];
    },
    set: function set(newVal) {
      this.$setExcludedOrders(newVal);
    }
  }, {
    key: "$includedOrders",
    get: function get() {
      return this.$store.getters['lastMileDelivery/includedOrders'];
    },
    set: function set(newVal) {
      this.$setIncludedOrders(newVal);
    }
  }, {
    key: "$selectedOrders",
    get: function get() {
      return this.$store.getters['lastMileDelivery/selectedOrders'];
    },
    set: function set(newVal) {
      this.$setSelectedOrders(newVal);
    }
  }, {
    key: "$orderFilters",
    get: function get() {
      return this.$store.getters['lastMileDelivery/orderFilters'];
    },
    set: function set(newVal) {
      this.$setOrderFilters(newVal);
    }
  }, {
    key: "$selectedColumns",
    get: function get() {
      return this.$store.getters['lastMileDelivery/selectedColumns'];
    },
    set: function set(newVal) {
      this.$setSelectedColumns(newVal);
    }
  }, {
    key: "driversList",
    get: function get() {
      return this.helper.orderBy(this.$drivers, [function (driver) {
        return driver['UserName'].toLowerCase();
      }], ['asc']);
    }
  }, {
    key: "$selectedDriver",
    get: function get() {
      return this.$store.getters['lastMileDelivery/selectedDriver'];
    },
    set: function set(newVal) {
      this.$setSelectedDriver(newVal);
    }
  }, {
    key: "$anyChanges",
    get: function get() {
      return this.$store.getters['lastMileDelivery/anyChanges'];
    },
    set: function set(newVal) {
      this.$setAnyChanges(newVal);
    }
  }, {
    key: "$isPlanExists",
    get: function get() {
      return this.$store.getters['lastMileDelivery/isPlanExists'];
    },
    set: function set(newVal) {
      this.$setPlanExists(newVal);
    }
  }, {
    key: "locked",
    get: function get() {
      var _this2 = this;

      return this.helper.get(this.helper.filter(this.$trucks, function (truck) {
        return truck['id'] === _this2.$selectedTruck;
      }), '0.locked', true);
    },
    set: function set(newVal) {
      var _this3 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this3.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['locked'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "currTruck",
    get: function get() {
      var _this4 = this;

      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === _this4.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "currPlanTruck",
    get: function get() {
      var _this5 = this;

      if (!this.$plan.trucks || this.$plan.trucks.length === 0) {
        return null;
      }

      return this.helper.get(this.$plan.trucks.filter(function (tData) {
        return tData['truckId'] === _this5.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "$truckFilters",
    get: function get() {
      return this.$store.getters['lastMileDelivery/truckFilters'];
    },
    set: function set(newVal) {
      this.$setTruckFilters(newVal);
    }
  }, {
    key: "blockedDrivers",
    get: function get() {
      return this.helper.get(this.$userInformation, 'blockedDrivers', []);
    }
  }, {
    key: "routes",
    get: function get() {
      return this.getRoutes(this.$selectedTruck);
    },
    set: function set(newVal) {
      var _this6 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this6.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['routes'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "$defaultTime",
    get: function get() {
      var startTime = this.$userSetting['default6'] || null;

      if (startTime) {
        return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format("YYYY-MM-DD ".concat(startTime)) : (0, _moment.default)(this.$planDate).format("YYYY-MM-DD ".concat(startTime));
      }

      return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format('YYYY-MM-DD HH:mm:00') : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 09:00:00');
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    }
  }, {
    key: "created",
    value: function created() {
      // const srtTime: string[] = process.env.VUE_APP_DEFAULT_START_WORKINGHR.split(':');
      // this.srtSeconds = (+srtTime[0]) * 60 * 60 + (+srtTime[1]) * 60 + (+srtTime[2]);
      // const endTime: string[] = process.env.VUE_APP_DEFAULT_END_WORKINGHR.split(':');
      // this.endSeconds = (+endTime[0]) * 60 * 60 + (+endTime[1]) * 60 + (+endTime[2]);
      if (!this.routeAPI) {
        this.routeAPI = new _route.RouteAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting
        });
      }

      if (!this.lastMileDeliveryAPI) {
        this.lastMileDeliveryAPI = new _lastMileDelivery.LastMileDeliveryAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting,
          lfToken: this.$lfToken || null
        });
      }

      if (!this.socketAPI) {
        this.socketAPI = new _socket.SocketAPI({
          lfToken: this.$lfToken || '',
          customerKey: this.$userInformation.customerKey || ''
        });
      }

      if (!this.planAPI) {
        this.planAPI = new _plan.PlanAPI({
          userSetting: this.$userSetting,
          lfCustKey: this.$lfCustKey || null,
          lfAPIToken: this.$lfAPIToken || null
        });
      }
    }
  }, {
    key: "getOrders",
    value: function getOrders() {
      var _this7 = this;

      var orderData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';
      var finalOrders = [];

      switch (type) {
        case 'save':
          if (orderData['data'] && orderData['data'].length >= 1) {
            orderData['data'].forEach(function (oData) {
              if (oData['routes'] && oData['routes'].length >= 1) {
                oData['routes'].forEach(function (rData) {
                  var finalOrder = finalOrders.length >= 1 ? finalOrders.find(function (fOrder) {
                    return fOrder['planId'] === rData['planId'];
                  }) : null;

                  if (finalOrder) {
                    finalOrder['orderId'] = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(finalOrder['orderId']), (0, _toConsumableArray2.default)(rData['orderId']))));
                  } else {
                    if (rData['planId'] && rData['orderId']) {
                      finalOrders.push({
                        planCode: code,
                        planId: rData['planId'],
                        orderId: (0, _toConsumableArray2.default)(new Set(rData['orderId']))
                      });
                    }
                  }
                });
              }
            });
          }

          break;

        case 'deleteAll':
          if (orderData['orders'] && orderData['orders'].length >= 1) {
            var orderIds = orderData['orders'].reduce(function (orderId, oData) {
              if (oData['id']) {
                orderId.push(oData['id']);
              }

              return orderId;
            }, []);
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderIds
            });
          }

          break;

        case 'deleteTruck':
          if (orderData['trucks'] && orderData['trucks'].length >= 1) {
            var _orderIds = orderData['trucks'].reduce(function (orderId, oData) {
              if (oData['orderId'].length >= 1 && oData['truckId'] === _this7.$selectedTruck) {
                orderId = [].concat((0, _toConsumableArray2.default)(orderId), (0, _toConsumableArray2.default)(oData['orderId']));
              }

              return orderId;
            }, []);

            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: _orderIds
            });
          }

          break;

        case 'deleteOnList':
          if (orderData['orderId'] && orderData['orderId'].length >= 1) {
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderData['orderId']
            });
          }

          break;
      }

      if (this.$includedOrders && this.$includedOrders.length >= 1) {
        finalOrders.push({
          planCode: '',
          planId: '',
          orderId: this.$includedOrders
        });
      }

      return finalOrders;
    }
  }, {
    key: "isInvalidOrder",
    value: function isInvalidOrder(order) {
      var bool = false;

      if (order.waypoints && order.waypoints.length >= 2) {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          return true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          return true;
        }
        /*if (this.helper.some(order['waypoints'], i => i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null)) {
        return true;
        }*/


        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0 || parseFloat(order['weight']) === 0 && parseFloat(order['volume']) === 0) {
            bool = true;
          }
        });
      } else {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "getInvalidOrderDetails",
    value: function getInvalidOrderDetails(order) {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false,
        reason4: false,
        reason5: false,
        reason6: false
      };

      if (order['waypoints'].length < 2) {
        reason.reason1 = true;
      } else {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          reason.reason2 = true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          reason.reason2 = true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0) {
            reason.reason3 = true;
          }

          if (parseFloat(order['volume']) === 0) {
            reason.reason4 = true;
          }

          if (parseFloat(order['weight']) === 0) {
            reason.reason5 = true;
          }
        });

        if (this.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          reason.reason6 = true;
        }
      }

      return reason;
    }
  }, {
    key: "formatRoutes",
    value: function formatRoutes(routes) {
      var isCalculateETA = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return routes.map(function (routeData) {
        routeData['startTime'] = isCalculateETA ? routeData['startTime'] : null;
        routeData['estimateTime'] = isCalculateETA ? routeData['estimateTime'] : null;
        return routeData;
      });
    }
  }, {
    key: "getTruckInfo",
    value: function getTruckInfo(truckId) {
      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getTruckInPlan",
    value: function getTruckInPlan(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "getTruckPlanIdsByTruckId",
    value: function getTruckPlanIdsByTruckId(truckId) {
      var truck = this.getTruckInPlan(truckId);

      if (truckId && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "getWaypointsFromIds",
    value: function getWaypointsFromIds(waypointIds) {
      var _this8 = this;

      var waypoints = [];
      var orderIds = this.helper.uniq(this.helper.map(waypointIds, function (id) {
        return parseInt(id.split('-')[0], 10);
      }));
      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this8.helper.includes(orderIds, parseInt(order['id'], 10));
      });
      this.helper.forEach(filteredOrders, function (order) {
        _this8.helper.forEach(order['waypoints'], function (waypoint) {
          _this8.helper.forEach(waypointIds, function (wpId) {
            if (waypoint['id'] === wpId) {
              waypoints.push(waypoint);
              return false;
            }
          });
        });
      });
      return filteredOrders.length > 0 ? waypoints : [];
    }
  }, {
    key: "getWaypointFromId",
    value: function getWaypointFromId(waypointId, fieldName) {
      var orderId = parseInt(waypointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(waypointId.split('-')[1], 10) || null;

      if (!orderId || !waypointIndex) {
        return null;
      }

      var order = this.$plan['orders'].filter(function (o) {
        return o['id'] === orderId;
      });

      if (!order || order.length === 0) {
        return '';
      } // const waypoint = order[0].waypoints[waypointIndex - 1];


      var waypoint = this.helper.find(order[0].waypoints, function (wp) {
        return wp.id === waypointId;
      });

      if (!waypoint || waypoint.length === 0) {
        return '';
      }

      return waypoint[fieldName];
    }
  }, {
    key: "getOrderField",
    value: function getOrderField(orderId, fieldName) {
      var selectedOrder = this.helper.get(this.helper.filter(this.$plan['orders'], function (order) {
        return order['id'] === parseInt(orderId, 10);
      }), '0', null);

      if (selectedOrder) {
        return selectedOrder[fieldName];
      }

      return null;
    }
  }, {
    key: "getOrdersField",
    value: function getOrdersField(orderIds, fieldName) {
      var _this9 = this;

      var filteredOrders = this.$plan.orders.filter(function (o) {
        return orderIds.includes(o.id);
      });

      if (this.helper.isUndefined(filteredOrders) || filteredOrders.length === 0) {
        return [];
      }

      return filteredOrders.map(function (o) {
        return o[fieldName];
      }).filter(function (v) {
        return !_this9.helper.isUndefined(v);
      });
    }
  }, {
    key: "adhocAssignV2",
    value: function () {
      var _adhocAssignV = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var isNewTruckObj,
            param,
            payload,
            res,
            message,
            response,
            invalidReasons,
            _message,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isNewTruckObj = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                param = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                payload = null;

                if (isNewTruckObj) {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                    routes: data['orders'],
                    vehicles: {
                      code: data['truck']['truckId'],
                      zone: data['truck']['zone'],
                      truckCommodityType: data['truck']['truckCommodityType'],
                      plateNumber: data['truck']['plateNumber'],
                      capacity1: parseFloat(data['truck']['weight']),
                      capacity2: parseFloat(data['truck']['volume']),
                      capacity3: parseFloat(data['truck']['assemblyMinutes']),
                      workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                      driverId: this.$selectedDriver
                    },
                    planIds: data['planIds']
                  };
                } else {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: data['startTime'],
                    routes: data['orders'],
                    vehicles: data['truck'],
                    planId: data['planId']
                  };
                }

                _context.next = 6;
                return this.routeAPI.adhocAssignV2(payload, param);

              case 6:
                res = _context.sent;

                if (data['truck'] && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles) {
                  _context.next = 11;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context.abrupt("return", null);

              case 11:
                response = res.data;
                invalidReasons = [];

                if (response['invalid'].length > 0) {
                  _message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(_message);

                  response['invalid'].forEach(function (item) {
                    var reason = item['reason'];

                    if (invalidReasons.filter(function (i) {
                      return i['reason'] === reason;
                    }).length === 0) {
                      invalidReasons.push({
                        reason: reason,
                        orderId: item.orderId,
                        shipmentReference: item.shipmentReference
                      });
                    } else {
                      var index = invalidReasons.findIndex(function (i) {
                        return i['reason'] === reason;
                      });

                      if (index !== -1) {
                        invalidReasons[index]['orderId'].push(item.orderId);
                        invalidReasons[index]['shipmentReference'].push(item.shipmentReference);
                      }
                    }
                  });
                }

                return _context.abrupt("return", {
                  invalidReasons: invalidReasons,
                  vehicles: response.vehicles
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function adhocAssignV2(_x) {
        return _adhocAssignV.apply(this, arguments);
      }

      return adhocAssignV2;
    }()
  }, {
    key: "manualAssign",
    value: function () {
      var _manualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, isTransfer) {
        var res, invalid, message, response, invalidReasons, _message2, _message3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.routeAPI.manualAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  // 'startDateTime': this.getAutoTime(data['startTime'], data['orders']),
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: {
                    code: data['truck']['truckId'],
                    zone: data['truck']['zone'],
                    truckCommodityType: data['truck']['truckCommodityType'],
                    plateNumber: data['truck']['plateNumber'],
                    capacity1: parseFloat(data['truck']['weight']),
                    capacity2: parseFloat(data['truck']['volume']),
                    capacity3: parseFloat(data['truck']['assemblyMinutes']),
                    workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: this.$selectedDriver
                  },
                  planIds: data['planIds']
                }, isTransfer);

              case 2:
                res = _context2.sent;
                invalid = this.helper.get(res, 'data.invalid', []);

                if (!(!(data.truck && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles) && invalid.length === 0)) {
                  _context2.next = 8;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", null);

              case 8:
                response = res.data;
                invalidReasons = [];

                if (response['invalid'].length > 0) {
                  if (this.helper.isUndefined(response.vehicles) || Object.entries(response.vehicles).length === 0 && response.vehicles.constructor === Object) {
                    _message2 = {
                      title: this.$i18n.t('planning.messages.failedInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.warning(_message2);
                  } else {
                    _message3 = {
                      title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.success(_message3);
                  }

                  response['invalid'].forEach(function (item) {
                    var reason = item['reason'];

                    if (invalidReasons.filter(function (i) {
                      return i['reason'] === reason;
                    }).length === 0) {
                      invalidReasons.push({
                        reason: reason,
                        orderId: item.orderId,
                        shipmentReference: item.shipmentReference
                      });
                    } else {
                      var index = invalidReasons.findIndex(function (i) {
                        return i['reason'] === reason;
                      });

                      if (index !== -1) {
                        invalidReasons[index]['orderId'].push(item.orderId);
                        invalidReasons[index]['shipmentReference'].push(item.shipmentReference);
                      }
                    }
                  });
                }

                return _context2.abrupt("return", {
                  invalidReasons: invalidReasons,
                  vehicles: response.vehicles
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function manualAssign(_x2, _x3) {
        return _manualAssign.apply(this, arguments);
      }

      return manualAssign;
    }()
  }, {
    key: "autoAssign",
    value: function () {
      var _autoAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _this10 = this;

        var locationType, vehicles, disabledTrucks, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Insert log
                this.insertLogs('auto assign', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  routes: data['orders'] ? data['orders'].map(function (oData) {
                    return {
                      shipmentReference: oData['shipmentReference'] || '',
                      orderId: oData['id'] || ''
                    };
                  }) : [],
                  type: this.$locationType,
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                locationType = this.$locationType && this.$locationType === 'dropoff' ? 'drop' : 'pick';
                vehicles = [];
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                this.$trucks.forEach(function (truck) {
                  if (_this10.isValidTruck(truck) && !_this10.helper.includes(disabledTrucks, truck['id'].toString())) {
                    vehicles.push({
                      code: truck['id'],
                      zone: truck['zone'],
                      truckCommodityType: truck['truckCommodityType'],
                      plateNumber: truck['plateNumber'],
                      capacity1: parseFloat(truck['weight']),
                      capacity2: parseFloat(truck['volume']),
                      capacity3: parseFloat(truck['assemblyMinutes']),
                      workingHours: truck['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                      driverId: truck['drivers'].length > 0 ? truck['drivers'][0]['id'] : null
                    });
                  }
                });

                if (!(vehicles.length > 0)) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 9;
                return this.routeAPI.autoAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  // startDateTime: this.getAutoTime(data['startTime'], data['orders']),
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD HH:mm:00'),
                  routes: data['orders'],
                  vehicles: this.getAvailableVehicles(vehicles)
                }, locationType);

              case 9:
                res = _context3.sent;
                return _context3.abrupt("return", res.data);

              case 13:
                return _context3.abrupt("return", {
                  error: 'noTrucks'
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function autoAssign(_x4) {
        return _autoAssign.apply(this, arguments);
      }

      return autoAssign;
    }()
    /*getAutoTime(startTime: string, orders: Array<any>): string {
    const dateAndTime: string[] = startTime.split(' ');
    let defaultStartTime = (startTime) ? new Date(startTime).getTime() : new Date().getTime();
    if (orders && orders.length >= 1 && dateAndTime.length === 2) {
      orders.forEach( (orderData) => {
        if (orderData['waypoints'] && orderData['waypoints'].length >= 1) {
          orderData['waypoints'].forEach( (wpData) => {
            if (wpData['startTime']) {
              const nDateAndTime: string[] = wpData['startTime'].split(' ');
              if (nDateAndTime.length === 2) {
                const nDateTime = `${dateAndTime[0]} ${nDateAndTime[1]}`;
                const nTime = new Date(nDateTime).getTime();
                if (defaultStartTime <= nTime) {
                  defaultStartTime = nTime;
                  startTime = nDateTime;
                }
              }
            }
          });
        }
      });
    }
     return startTime;
    }*/

  }, {
    key: "isValidTruck",
    value: function isValidTruck(truck) {
      var isTimeWindow = this.$userSetting.default2;
      var truckRoutes = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truck['id'];
      }), '0.routes', []); // let truckPercentage: number = 70;
      // if (isTimeWindow) {
      // 	truckPercentage = Math.round(Number(this.$userSetting.default17 || 70) / 2);
      // 	return truckRoutes.length === 0;
      // } else {
      // 	truckPercentage = Number(this.$userSetting.default17 || 70);
      // }
      // let truckPercentage: number = Number(this.$userSetting.default17 || 70);
      // if (isTimeWindow) {
      // 	truckPercentage = truckPercentage >= 50 ? truckPercentage - 10 : truckPercentage; // reduce the truck percentage by 10
      // } else {
      // 	truckPercentage = truckPercentage >= 90 ? 90 : truckPercentage; // max 90 because of 10% padding on backend
      // }

      var truckPercentage = Number(this.$userSetting.default17 || 70);

      if (truckPercentage >= 90) {
        truckPercentage = 90;
      }

      var srtTime = (truck['workingHours'][0] || process.env.VUE_APP_DEFAULT_START_WORKINGHR).split(':');
      var srtSeconds = +srtTime[0] * 60 * 60 + +srtTime[1] * 60 + +srtTime[2];
      var endTime = (truck['workingHours'][1] || process.env.VUE_APP_DEFAULT_END_WORKINGHR).split(':');
      var endSeconds = +endTime[0] * 60 * 60 + +endTime[1] * 60 + +endTime[2];
      var truckLimit = truckPercentage / 100 * Number(endSeconds - srtSeconds); // const truckLimit: number = (truckPercentage / 100) * Number(endSeconds);

      var truckWeight = truckPercentage / 100 * Number(truck['weight']);
      var truckVolume = truckPercentage / 100 * Number(truck['volume']);
      var isValid = false;

      if (truckRoutes.length >= 2) {
        var truckLastRouteCount = this.getRouteNumbers(truckRoutes);

        if (truckWeight > Number(truckLastRouteCount['capacity1']) && truckVolume > Number(truckLastRouteCount['capacity2']) && truckLimit > Number(truckLastRouteCount['time'])) {
          isValid = true;
        }
      } else {
        isValid = true;
      }

      return (// this.helper.get(this.helper.filter(this.$plan.trucks, t => t['truckId'] === truck['id']), '0.routes', []).length === 0 &&
        isValid && parseFloat(truck['weight']) > 0 && parseFloat(truck['volume']) > 0
      );
    }
  }, {
    key: "calculateETA",
    value: function () {
      var _calculateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload, type) {
        var routes, sortedRoutes, startTime, res, title;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                routes = this.helper.cloneDeep(payload.routes);
                sortedRoutes = this.helper.cloneDeep(payload.routes).sort(function (a, b) {
                  if (a['runningTime'] > b['runningTime']) {
                    return 1;
                  }

                  if (b['runningTime'] > a['runningTime']) {
                    return -1;
                  }

                  return 0;
                });
                startTime = payload.startTime ? payload.startTime : routes[0].startTime;

                if (type === 'REORDER') {
                  startTime = payload.index === 0 ? sortedRoutes[0].startTime : routes[payload.index].startTime;
                }

                _context4.next = 6;
                return this.routeAPI.calculateETA({
                  company: this.$userInformation.company.name,
                  code: this.$planDate,
                  // startDateTime: type === 'REORDER' ? routes[0].startTime : startTime,
                  // startIndex: type === 'REORDER' ? 0 : payload.index,
                  startDateTime: startTime,
                  startIndex: payload.index,
                  routes: this.formatRoutes(routes, true),
                  locked: payload.isLocked,
                  deletedOrders: payload.deletedOrders
                });

              case 6:
                res = _context4.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", null);

              case 9:
                // Insert log
                title = this.helper.isUndefined(type === 'REORDER') ? 'reorder route' : 'update route eta';
                this.insertLogs(title, {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  truckId: this.$selectedTruck,
                  payload: payload,
                  request: {
                    company: this.$userInformation.company.name,
                    code: this.$planDate,
                    startDateTime: startTime,
                    startIndex: payload.index,
                    routes: this.formatRoutes(routes, true),
                    locked: payload.isLocked,
                    deletedOrders: payload.deletedOrders
                  },
                  response: res.data,
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                this.$anyChanges = true;
                return _context4.abrupt("return", res.data);

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function calculateETA(_x5, _x6) {
        return _calculateETA.apply(this, arguments);
      }

      return calculateETA;
    }()
    /**
     * Recalculate routes after deletion of completed orders
     * */

  }, {
    key: "reCalculateOfDeletedCompletedRoutes",
    value: function () {
      var _reCalculateOfDeletedCompletedRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload) {
        var routes, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                routes = this.helper.cloneDeep(payload.routes);
                _context5.next = 3;
                return this.routeAPI.removeCompletedOrders({
                  company: this.$userInformation.company.name,
                  code: this.$planDate,
                  routes: this.formatRoutes(routes, true),
                  deletedOrders: payload.deletedOrders
                });

              case 3:
                res = _context5.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", null);

              case 6:
                this.$anyChanges = true;
                return _context5.abrupt("return", res.data);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function reCalculateOfDeletedCompletedRoutes(_x7) {
        return _reCalculateOfDeletedCompletedRoutes.apply(this, arguments);
      }

      return reCalculateOfDeletedCompletedRoutes;
    }()
  }, {
    key: "updateCurrentTruck",
    value: function updateCurrentTruck(response) {
      var _this11 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this11.$selectedTruck;
        });

        if (index !== -1) {
          if (response.routes.length === 0) {
            if (plan.hasOwnProperty('truckId')) {
              plan['truckId'] = plan['truckId'].filter(function (tId) {
                return tId !== _this11.$selectedTruck;
              });
            }

            plan['trucks'].splice(index, 1);
          } else {
            plan['trucks'][index]['estimatedDistance'] = response['estimatedDistance'];
            plan['trucks'][index]['estimatedTime'] = response['estimatedTime'];
            plan['trucks'][index]['routes'] = response['routes'];
          }
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "isGenerateNewPlanId",
    value: function isGenerateNewPlanId(truckObj) {
      var _this12 = this;

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'unassigned';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this12.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'assigned';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this12.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'assigned';
      }) && this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'unassigned';
      })) {
        var assignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'assigned';
        });
        var unassignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'unassigned';
        });
        return this.helper.every(assignedRoutes, function (r) {
          return !_this12.helper.isUndefined(r.planId);
        }) && this.helper.every(unassignedRoutes, function (r) {
          return _this12.helper.isUndefined(r.planId);
        });
      }

      return false;
    }
  }, {
    key: "savePlan",
    value: function () {
      var _savePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this13 = this;

        var plan,
            isAutoAssign,
            isUpdateSocket,
            bufferPlan,
            i,
            indexes,
            cancelDriverAssignmentResponse,
            m,
            prefix,
            newPlanIds,
            payload,
            saveRes,
            message,
            updateInitOrderIdsPayload,
            updateOrderIdsPayload,
            updateOrderRes,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                plan = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : this.$plan;
                isAutoAssign = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                isUpdateSocket = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                bufferPlan = this.helper.cloneDeep(plan);
                i = 0;
                indexes = [];

                if (!(this.$toBeUnassignedOrderIds.length > 0)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 11;
                return this.cancelDriverAssignment(this.$toBeUnassignedOrderIds);

              case 11:
                cancelDriverAssignmentResponse = _context6.sent;

                if (cancelDriverAssignmentResponse) {
                  _context6.next = 16;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 16:
                if (!this.$isAssignedDriverChanges) {
                  _context6.next = 22;
                  break;
                }

                m = {
                  title: this.$i18n.t('planning.messages.assignedDriverChanges'),
                  duration: 5000
                };

                _elementUi.Notification.warning(m);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 22:
                this.helper.forEach(bufferPlan['trucks'], function (truck, index) {
                  var isGenerateNewPlanId = _this13.isGenerateNewPlanId(truck);

                  if (isGenerateNewPlanId) {
                    i++;
                    indexes.push(index);
                  }

                  var lastIdxWithPlanId = _this13.helper.findLastIndex(truck.routes, function (route) {
                    return !_this13.helper.isUndefined(route.planId);
                  });

                  var id = lastIdxWithPlanId !== -1 ? truck.routes[lastIdxWithPlanId].planId : null;
                  truck.estimatedDistance = _this13.getRouteDetails(truck.truckId)['estimatedDistance'];
                  truck.estimatedTime = _this13.getRouteDetails(truck.truckId)['estimatedTime'];

                  _this13.helper.forEach(truck['routes'], function (route) {
                    route.isHighlighted = false;

                    if (lastIdxWithPlanId !== -1 && _this13.helper.isUndefined(route.planId) && !isGenerateNewPlanId) {
                      route.planId = id;
                    }
                  });
                }); // const date = moment(this.$planDate).format('YYMMDD');
                // const prefix = this.helper.generatePlanId(date, this.$userInformation.company.name);

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context6.next = 26;
                return this.routeAPI.generateLoadPlanId(prefix, i);

              case 26:
                newPlanIds = _context6.sent;
                newPlanIds = this.helper.get(newPlanIds, 'data', []);
                this.helper.forEach(indexes, function (value, index) {
                  var id = newPlanIds[index];
                  bufferPlan.trucks[value].routes.forEach(function (route) {
                    if (_this13.helper.isUndefined(route.planId)) {
                      route.planId = id;
                    }
                  });
                  bufferPlan.trucks[value].planId = _this13.helper.uniq(bufferPlan.trucks[value].routes.map(function (x) {
                    return x['planId'];
                  }));
                });
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (truck) {
                  return truck['planId'];
                }));
                payload = {
                  user: this.$userInformation.user.name,
                  code: bufferPlan['code'],
                  orderId: this.helper.map(bufferPlan['orders'], 'id'),
                  truckId: this.helper.map(bufferPlan['trucks'], 'truckId'),
                  planId: bufferPlan['planId'],
                  data: bufferPlan['trucks'].map(function (tData) {
                    delete tData['drivers'];
                    delete tData['orders'];
                    delete tData['trucks'];
                    tData['routes'].map(function (routeData) {
                      delete routeData['orders'];
                      delete routeData['masterpoints'];
                      delete routeData['waypoints']; // routeData['waitingTime'] = Number(routeData['waitingTime']) * 60;
                      // routeData['handlingTime'] = Number(routeData['handlingTime']) * 60;
                      // routeData['time'] = Number(routeData['time']) * 60; // time

                      return routeData;
                    });
                    return tData;
                  })
                };

                if (!this.$isPlanExists) {
                  _context6.next = 37;
                  break;
                }

                _context6.next = 34;
                return this.lastMileDeliveryAPI.updatePlan(payload);

              case 34:
                saveRes = _context6.sent;
                _context6.next = 40;
                break;

              case 37:
                _context6.next = 39;
                return this.lastMileDeliveryAPI.insertPlan(payload);

              case 39:
                saveRes = _context6.sent;

              case 40:
                message = {
                  title: this.$i18n.t('general.updateSuccess'),
                  duration: 5000
                }; // if (!(saveRes && saveRes.data && updateRes)) {

                if (saveRes && saveRes.data) {
                  _context6.next = 47;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 47:
                if (isUpdateSocket) {
                  // if (!isAutoAssign) {
                  // TEMPORARY SHOULD REMOVE IF
                  // Socket for global plan
                  this.socketAPI.updateLMDGlobalPlan({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    code: this.$planDate
                  }); // }
                  // Socket for global orders

                  this.socketAPI.updateLMDGlobalSelectedOrders({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    orderId: [],
                    dataType: 'removeAll'
                  });
                } // remove old orders


                if (!(isAutoAssign && this.$planInitOrderIds && this.$planInitOrderIds.length >= 1)) {
                  _context6.next = 53;
                  break;
                }

                updateInitOrderIdsPayload = {
                  orders: this.getOrders({
                    orderId: this.$planInitOrderIds
                  }, '', 'deleteOnList')
                };

                if (!(updateInitOrderIdsPayload['orders'].length >= 1)) {
                  _context6.next = 53;
                  break;
                }

                _context6.next = 53;
                return this.lastMileDeliveryAPI.updateOrdersInPlan(updateInitOrderIdsPayload);

              case 53:
                // remove old orders
                // Hide the assigned order from the table
                updateOrderIdsPayload = {
                  orders: this.getOrders(payload, payload['code'], 'save')
                };

                if (!(updateOrderIdsPayload['orders'].length >= 1)) {
                  _context6.next = 64;
                  break;
                }

                _context6.next = 57;
                return this.lastMileDeliveryAPI.updateOrdersInPlan(updateOrderIdsPayload);

              case 57:
                updateOrderRes = _context6.sent;

                if (updateOrderRes) {
                  _context6.next = 64;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 64:
                this.$setPlan({
                  plan: bufferPlan
                }); // this.$setPlanInitOrderIds(this.helper.map(bufferPlan['orders'], 'id'));

                this.$failedOrders = [];
                this.$resetPlan();
                this.$anyChanges = false;
                this.$isPlanExists = true;

                _elementUi.Notification.success(message);

                if (isAutoAssign) {
                  _context6.next = 73;
                  break;
                }

                _context6.next = 73;
                return this.$getUnassignedOrders();

              case 73:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                this.insertLogs('save plan', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  planIds: (0, _toConsumableArray2.default)(bufferPlan.planId),
                  trucks: bufferPlan && bufferPlan.trucks.length ? bufferPlan.trucks.map(function (truck) {
                    return {
                      truckId: truck.truckId,
                      plateNumber: truck.plateNumber,
                      driverIds: truck.driverId
                    };
                  }) : [],
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                return _context6.abrupt("return", true);

              case 77:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function savePlan() {
        return _savePlan.apply(this, arguments);
      }

      return savePlan;
    }()
    /*async deletePlan(isAutoAssign: boolean = false) {
    const message: ElNotificationOptions = {
      title: this.$i18n.t('general.deleteFailed'),
      duration: 5000
    } as ElNotificationOptions;
    const orderIds = this.helper.map(this.$plan['orders'], 'id') || [];
    const updateOrderIdsPayload = {
      'code': '',
      'orders': this.getOrders(this.$plan, '', 'deleteAll')
    };
     if (this.isSomeOrdersAssigned) {
      const orderShipRefs = this.getShipRefsFromOrderId(orderIds);
      const payload = [];
      orderShipRefs.forEach(order => {
        payload.push({ shipref: order });
      });
      const cancelDriverAssignmentResponse = await this.cancelDriverAssignment(payload);
      if (!cancelDriverAssignmentResponse) {
        return false;
      }
    }
     const deleteRes = await this.lastMileDeliveryAPI.deletePlan(this.$plan['code'], {});
    if (!deleteRes) {
      Notification.error(message);
      return false;
    }
     if (updateOrderIdsPayload['orders'].length >= 1) {
      const updateRes = await this.lastMileDeliveryAPI.updateOrdersInPlan(updateOrderIdsPayload);
      if (!updateRes) {
        Notification.error(message);
        return false;
      }
    }
     this.$anyChanges = false;
    this.$isPlanExists = false;
    message['title'] = <string> this.$i18n.t('general.deleteSuccess');
    Notification.success(message);
     this.$resetPlan();
    this.$setPlan({ 'isReset': true });
    if (!isAutoAssign) {
      await this.$getUnassignedOrders();
    }
    }*/

  }, {
    key: "deleteRoutesInTruck",
    value: function () {
      var _deleteRoutesInTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var isAutoAssign,
            message,
            isSomeOrdersAssigned,
            shipRefFromOrder,
            driverAssignPayload,
            cancelDriverAssignmentResponse,
            updateOrderIdsPayload,
            updateOrderRes,
            deletePayload,
            deleteRes,
            bufferPlan,
            updatedPlan,
            _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                isAutoAssign = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : false;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                message = {
                  title: this.$i18n.t('general.deleteFailed'),
                  duration: 5000
                };
                isSomeOrdersAssigned = false;
                shipRefFromOrder = this.getShipRefsFromOrders();

                if (!(shipRefFromOrder.length === 0)) {
                  _context7.next = 10;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 10:
                if (!(this.$plan && this.$plan.trucks && this.$plan.trucks.length >= 1)) {
                  _context7.next = 16;
                  break;
                }

                if (this.currTruck) {
                  _context7.next = 15;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 15:
                isSomeOrdersAssigned = this.currPlanTruck['routes'].some(function (route) {
                  return route.status.toUpperCase() === 'ASSIGNED' || route.status.toUpperCase() === 'COMPLETED';
                });

              case 16:
                if (!(isSomeOrdersAssigned && shipRefFromOrder.length >= 1)) {
                  _context7.next = 26;
                  break;
                }

                driverAssignPayload = [];
                shipRefFromOrder.forEach(function (order) {
                  driverAssignPayload.push({
                    shipref: order
                  });
                });
                _context7.next = 21;
                return this.cancelDriverAssignment(driverAssignPayload);

              case 21:
                cancelDriverAssignmentResponse = _context7.sent;

                if (cancelDriverAssignmentResponse) {
                  _context7.next = 26;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 26:
                if (!(this.$includedOrders.length >= 1)) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 29;
                return this.savePlan(this.$plan, false, false);

              case 29:
                updateOrderIdsPayload = {
                  orders: this.getOrders(this.$plan, '', 'deleteTruck')
                };

                if (!(updateOrderIdsPayload['orders'].length >= 1)) {
                  _context7.next = 39;
                  break;
                }

                _context7.next = 33;
                return this.lastMileDeliveryAPI.updateOrdersInPlan(updateOrderIdsPayload);

              case 33:
                updateOrderRes = _context7.sent;

                if (updateOrderRes) {
                  _context7.next = 39;
                  break;
                }

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 39:
                deletePayload = {
                  user: this.$userInformation.user.name,
                  code: this.$plan['code'],
                  truckId: this.$selectedTruck
                };
                _context7.next = 42;
                return this.lastMileDeliveryAPI.deletePlan(this.$plan['code'], deletePayload);

              case 42:
                deleteRes = _context7.sent;

                if (deleteRes) {
                  _context7.next = 48;
                  break;
                }

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context7.abrupt("return", false);

              case 48:
                message['title'] = this.$i18n.t('general.deleteSuccess');

                _elementUi.Notification.success(message); // if (this.$anyChanges) {
                // Socket for global plan
                // if (!isAutoAssign) {
                // TEMPORARY SHOULD REMOVE IF


                this.socketAPI.updateLMDGlobalPlan({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  code: this.$planDate
                }); // }
                // Socket for global orders

                this.socketAPI.updateLMDGlobalSelectedOrders({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  orderId: [],
                  dataType: 'removeAll'
                }); // }

                bufferPlan = this.helper.cloneDeep(this.$plan);
                updatedPlan = this.removeTruckInPlan(bufferPlan, this.$selectedTruck);
                this.$anyChanges = false;
                this.$setPlan({
                  plan: updatedPlan
                });

                if (updatedPlan['trucks'].length === 0) {
                  this.$isPlanExists = false;
                  this.$setPlanExists(false);
                  this.$resetPlan();
                  this.$setPlan({
                    isReset: true
                  });
                }

                if (isAutoAssign) {
                  _context7.next = 60;
                  break;
                }

                _context7.next = 60;
                return this.$getUnassignedOrders();

              case 60:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                this.insertLogs('delete routes in truck', {
                  routeType: 'last-mile-delivery',
                  planDate: this.$planDate,
                  truckId: this.$selectedTruck,
                  truck: this.getTruckInfo(this.$selectedTruck),
                  user: this.$userInformation.user,
                  globalUsers: this.$GLOBAL_ACTIVE_USERS
                });
                return _context7.abrupt("return", true);

              case 64:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function deleteRoutesInTruck() {
        return _deleteRoutesInTruck.apply(this, arguments);
      }

      return deleteRoutesInTruck;
    }()
  }, {
    key: "removeTruckInPlan",
    value: function removeTruckInPlan(plan, truckId) {
      var newTruck = plan['trucks'].filter(function (tData) {
        return tData['truckId'] !== truckId;
      });

      if (newTruck.length === 0) {
        return {
          code: plan['code'],
          planDate: this.$planDate,
          planId: [],
          trucks: [],
          orders: []
        };
      }

      var newTruckIds = [];
      var newOrderIds = [];
      var newPlanIds = [];
      newTruck.forEach(function (ntData) {
        newOrderIds = [].concat((0, _toConsumableArray2.default)(newOrderIds), (0, _toConsumableArray2.default)(ntData['orderId']));
        newPlanIds = [].concat((0, _toConsumableArray2.default)(newPlanIds), (0, _toConsumableArray2.default)(ntData['planId']));
        newTruckIds.push(ntData['truckId']);
      });
      var newOrders = [];

      if (newOrderIds.length >= 1 && plan['orders']) {
        newOrders = plan['orders'].filter(function (noData) {
          return newOrderIds.includes(noData['id']);
        });
      }

      plan['planId'] = newPlanIds;
      plan['trucks'] = newTruck;
      plan['truckId'] = newTruckIds;
      plan['orders'] = newOrders;
      plan['orderId'] = newOrderIds;
      return plan;
    }
  }, {
    key: "getCarPlateFromDriverId",
    value: function getCarPlateFromDriverId(driverId) {
      var driver = this.helper.find(this.$drivers, function (item) {
        return item['RecId'] === driverId;
      });

      if (!this.helper.isUndefined(driver)) {
        return driver['Carplate'];
      }

      return null;
    }
  }, {
    key: "getShipRefsFromOrderId",
    value: function getShipRefsFromOrderId(orderId) {
      var _this14 = this;

      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this14.helper.includes(orderId, parseInt(order['id'], 10));
      });

      if (filteredOrders.length) {
        return this.helper.map(filteredOrders, 'shipmentReference');
      }

      return [];
    }
  }, {
    key: "getShipRefsFromOrders",
    value: function getShipRefsFromOrders() {
      var _this15 = this;

      var selectedTruck = this.helper.find(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this15.$selectedTruck;
      });

      if (selectedTruck) {
        return selectedTruck['shipmentReference'];
      }

      return [];
    }
  }, {
    key: "confirmUnsavedChanges",
    value: function confirmUnsavedChanges(to, from, next) {
      var _this16 = this;

      if (this.$anyChanges && to.name !== 'login') {
        var message = this.$i18n.t('planning.messages.unsavedChanges');

        _elementUi.MessageBox.confirm(message, 'Warning', {
          confirmButtonText: this.$i18n.t('pickColumns.confirm'),
          cancelButtonText: this.$i18n.t('pickColumns.cancel'),
          type: 'warning',
          center: true
        }).then(function () {
          _this16.$anyChanges = false;

          _this16.$resetPlan();

          next();
        }).catch(function () {
          next(false);
        });
      } else {
        this.$resetPlan(false);
        next();
      }
    }
  }, {
    key: "assignDriver",
    value: function () {
      var _assignDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(payload) {
        var _this17 = this;

        var res, status, response, iOrders;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                payload.forEach(function (payloadData) {
                  payloadData['handledate'] = _this17.$planDate;
                });
                _context8.next = 3;
                return this.planAPI.assignDriver(payload);

              case 3:
                res = _context8.sent;
                status = this.helper.get(res, 'data.status', 300);
                response = {
                  isSuccess: false,
                  invalidOrders: null
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context8.next = 10;
                  break;
                }

                iOrders = this.helper.get(res, 'data.errors', []);
                response['invalidOrders'] = iOrders.length ? this.helper.map(iOrders, 'shipref').join(', ') : '-';
                return _context8.abrupt("return", response);

              case 10:
                response['isSuccess'] = true;
                return _context8.abrupt("return", response);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function assignDriver(_x8) {
        return _assignDriver.apply(this, arguments);
      }

      return assignDriver;
    }()
  }, {
    key: "cancelDriverAssignment",
    value: function () {
      var _cancelDriverAssignment = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(payload) {
        var res, status, error, message;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.planAPI.cancelDriverAssignment(payload);

              case 2:
                res = _context9.sent;
                status = this.helper.get(res, 'data.status', 300);
                error = null;
                message = {
                  title: this.$i18n.t('planning.messages.cancelOrdersAssignmentSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context9.next = 11;
                  break;
                }

                error = this.helper.get(res, 'data.error', null);
                message['message'] = "".concat(this.$i18n.t('planning.messages.cancelOrdersAssignmentFailed'), " ").concat(this.$i18n.t('planning.messages.dueTo'), " ").concat(error);

                _elementUi.Notification.error(message);

                return _context9.abrupt("return", false);

              case 11:
                _elementUi.Notification.success(message);

                return _context9.abrupt("return", true);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function cancelDriverAssignment(_x9) {
        return _cancelDriverAssignment.apply(this, arguments);
      }

      return cancelDriverAssignment;
    }()
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      // const waypoints = this.getWaypointsFromIds(route['waypointId']);
      var cssClass = {
        'pick-up': route['waypointType'] === 'P',
        unassigned: false,
        assigned: false,
        completed: false
      };
      /*if (status === 'assigned' || status === 'completed') {
      this.helper.every(waypoints, (wp) => wp['completedTime'] !== null && wp['completedTime'] !== '0000-00-00 00:00:00') // all waypoints are completed
      ? cssClass['completed'] = true
      : this.helper.some(waypoints, (wp) => wp['completedTime'] !== null && wp['completedTime'] !== '0000-00-00 00:00:00') // some waypoints are completed
        ? cssClass['partial-completed'] = true
        : cssClass['partial-completed'] = true;
      }*/

      cssClass[route['status']] = true;
      return cssClass;
    }
  }, {
    key: "isRouteBelongToDifferentUser",
    value: function isRouteBelongToDifferentUser(route) {
      if (!route.hasOwnProperty('user')) {
        return false;
      }

      if (route.hasOwnProperty('user') && this.$userInformation && this.$userInformation.user) {
        return route['user'] !== this.$userInformation.user.name;
      }

      return false;
    }
  }, {
    key: "isSomePlanIdAssigned",
    value: function isSomePlanIdAssigned(planId) {
      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && route.status.toUpperCase() === 'ASSIGNED';
        });
      }

      return false;
    }
  }, {
    key: "isSomePlanIdCompleted",
    value: function isSomePlanIdCompleted(planId) {
      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && route.status.toUpperCase() === 'COMPLETED';
        });
      }

      return false;
    }
  }, {
    key: "isPlanIdBelongToDifferentUser",
    value: function isPlanIdBelongToDifferentUser(planId) {
      var _this18 = this;

      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && _this18.isRouteBelongToDifferentUser(route);
        }) && !isAllowEditOtherUserData;
      }

      return false;
    }
  }, {
    key: "createNewPlanIdRoutes",
    value: function () {
      var _createNewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref) {
        var _this19 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, orders, orderIds, message, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                planId = _ref.planId, startTime = _ref.startTime, truckId = _ref.truckId, unassignedOrders = _ref.unassignedOrders, isTransfer = _ref.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this19.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context10.next = 9;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context10.abrupt("return", null);

              case 9:
                _context10.next = 11;
                return this.manualAssign({
                  orders: orders,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: this.getTruckInfo(truckId),
                  planIds: [(0, _defineProperty2.default)({}, planId, orderIds)]
                }, isTransfer);

              case 11:
                res = _context10.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context10.next = 17;
                  break;
                }

                return _context10.abrupt("return", null);

              case 17:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context10.next = 21;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context10.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context10.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createNewPlanIdRoutes(_x10) {
        return _createNewPlanIdRoutes.apply(this, arguments);
      }

      return createNewPlanIdRoutes;
    }()
  }, {
    key: "updateExistingPlanIdRoutes",
    value: function () {
      var _updateExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref3) {
        var _this20 = this;

        var planId, startTime, truckObj, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, indexOccurence, otherRoutes, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                planId = _ref3.planId, startTime = _ref3.startTime, truckObj = _ref3.truckObj, unassignedOrders = _ref3.unassignedOrders, isTransfer = _ref3.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                indexOccurence = this.helper.findIndex(truckObj['routes'], function (route) {
                  return route.planId === planId;
                });
                otherRoutes = truckObj['routes'].filter(function (route) {
                  return route.planId !== planId;
                });
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this20.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds)));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this20.helper.includes(orderIds, order.id);
                });
                orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders)), function (i) {
                  return i.id;
                });
                _context11.next = 13;
                return this.manualAssign({
                  orders: orders,
                  startTime: startTime,
                  truck: this.getTruckInfo(truckObj['truckId']),
                  planIds: [(0, _defineProperty2.default)({}, planId, orderIds)]
                }, isTransfer);

              case 13:
                res = _context11.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context11.next = 19;
                  break;
                }

                return _context11.abrupt("return", null);

              case 19:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context11.next = 23;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context11.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                otherRoutes.splice.apply(otherRoutes, [indexOccurence, 0].concat((0, _toConsumableArray2.default)(res['vehicles']['routes'])));
                return _context11.abrupt("return", {
                  vehicles: _objectSpread(_objectSpread({}, vehicles), {}, {
                    truckId: truckObj['truckId'],
                    // driverId: this.$selectedDriver,
                    locked: false,
                    orderId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(orderIds))).filter(function (order) {
                      return !_this20.helper.includes(invalidOrderIds, order);
                    }),
                    planId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'].planId))),
                    projectCode: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['projectCode']), (0, _toConsumableArray2.default)(res['vehicles'].projectCode))),
                    routes: otherRoutes,
                    shipmentReference: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['shipmentReference']), (0, _toConsumableArray2.default)(res['vehicles'].shipmentReference)))
                  }),
                  orders: selectedOrders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 26:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function updateExistingPlanIdRoutes(_x11) {
        return _updateExistingPlanIdRoutes.apply(this, arguments);
      }

      return updateExistingPlanIdRoutes;
    }()
  }, {
    key: "adHocV2NewPlanIdRoutes",
    value: function () {
      var _adHocV2NewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref5) {
        var _this21 = this;

        var planId, startTime, truckId, unassignedOrders, isShowFailedOrders, failedOrders, orders, orderIds, message, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                planId = _ref5.planId, startTime = _ref5.startTime, truckId = _ref5.truckId, unassignedOrders = _ref5.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this21.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context12.next = 9;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context12.abrupt("return", null);

              case 9:
                _context12.next = 11;
                return this.adhocAssignV2({
                  orders: orders,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: this.getTruckInfo(truckId),
                  planIds: [(0, _defineProperty2.default)({}, planId, orderIds)]
                }, true);

              case 11:
                res = _context12.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context12.next = 17;
                  break;
                }

                return _context12.abrupt("return", null);

              case 17:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context12.next = 21;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context12.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context12.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 23:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function adHocV2NewPlanIdRoutes(_x12) {
        return _adHocV2NewPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2NewPlanIdRoutes;
    }()
  }, {
    key: "adHocV2ExistingPlanIdRoutes",
    value: function () {
      var _adHocV2ExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(_ref7) {
        var _this22 = this;

        var planId, startTime, truckObj, unassignedOrders, isShowFailedOrders, failedOrders, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, param, firstRouteStatus, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                planId = _ref7.planId, startTime = _ref7.startTime, truckObj = _ref7.truckObj, unassignedOrders = _ref7.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this22.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds)));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this22.helper.includes(orderIds, order.id);
                });
                orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders)), function (i) {
                  return i.id;
                });
                param = {};
                firstRouteStatus = this.helper.get(truckObj, 'routes.0.status', 'unassigned');

                if (firstRouteStatus === 'assigned') {
                  param['status'] = 'assigned';
                }

                _context13.next = 14;
                return this.adhocAssignV2({
                  orders: this.helper.uniqBy(selectedOrders, function (i) {
                    return i.id;
                  }),
                  startTime: startTime,
                  truck: truckObj,
                  planId: planId
                }, false, param);

              case 14:
                res = _context13.sent;
                vehicles = this.helper.get(res, 'vehicles', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.flatten(invalidReasons.map(function (item) {
                  return item['orderId'];
                }));

                if (!this.helper.isUndefined(res)) {
                  _context13.next = 20;
                  break;
                }

                return _context13.abrupt("return", null);

              case 20:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context13.next = 24;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context13.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context13.abrupt("return", {
                  truck: res['vehicles'],
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 26:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function adHocV2ExistingPlanIdRoutes(_x13) {
        return _adHocV2ExistingPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2ExistingPlanIdRoutes;
    }()
  }, {
    key: "handleNewTruckObj",
    value: function () {
      var _handleNewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(args) {
        var _this23 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                _context14.next = 7;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 7:
                res = _context14.sent;

                if (!this.helper.isUndefined(res)) {
                  _context14.next = 10;
                  break;
                }

                return _context14.abrupt("return");

              case 10:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context14.next = 13;
                  break;
                }

                return _context14.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 13:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                /*plan.orders = [
                ...plan.orders,
                ...orders
                ].filter((obj, pos, arr) => {
                if (!this.helper.includes(invalidOrderIds, obj['id'])) {
                return arr.map(mapObj => mapObj.id).indexOf(obj.id) === pos;
                }
                });*/

                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this23.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context14.next = 21;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 21:
                this.logger.info('Init Truck: ', truck, 'Plan: ', plan);
                return _context14.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function handleNewTruckObj(_x14) {
        return _handleNewTruckObj.apply(this, arguments);
      }

      return handleNewTruckObj;
    }()
  }, {
    key: "handleExistingTruckObj",
    value: function () {
      var _handleExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(args) {
        var _this24 = this;

        var planId, isNewPlanId, truckObj, unassignedOrders, isTransfer, truckIndex, startTime, res, isShowFailedOrders, failedOrders, truck, plan;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                planId = args.planId;
                isNewPlanId = args.isNewPlanId || false;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                startTime = this.routes[this.routes.length - 1]['endTime'];

                if (!isNewPlanId) {
                  _context15.next = 13;
                  break;
                }

                _context15.next = 10;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckObj['truckId'],
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 10:
                _context15.t0 = _context15.sent;
                _context15.next = 16;
                break;

              case 13:
                _context15.next = 15;
                return this.updateExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 15:
                _context15.t0 = _context15.sent;

              case 16:
                res = _context15.t0;

                if (!this.helper.isUndefined(res)) {
                  _context15.next = 19;
                  break;
                }

                return _context15.abrupt("return");

              case 19:
                isShowFailedOrders = res.isShowFailedOrders;
                failedOrders = res.failedOrders;
                truck = null;

                if (!(this.helper.isUndefined(res['vehicles']) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context15.next = 24;
                  break;
                }

                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (isNewPlanId) {
                  truck = _objectSpread(_objectSpread({}, res['vehicles']), {}, {
                    truckId: truckObj['truckId'],
                    locked: false,
                    driverId: [].concat((0, _toConsumableArray2.default)(truckObj['driverId']), (0, _toConsumableArray2.default)(res['vehicles']['driverId'])),
                    orderId: [].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(res['orderIds'])).filter(function (order) {
                      return !_this24.helper.includes(res.invalidOrderIds, order);
                    }),
                    planId: [].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'].planId)),
                    projectCode: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['projectCode']), (0, _toConsumableArray2.default)(res['vehicles'].projectCode))),
                    routes: [].concat((0, _toConsumableArray2.default)(truckObj['routes']), (0, _toConsumableArray2.default)(res['vehicles'].routes)),
                    shipmentReference: [].concat((0, _toConsumableArray2.default)(truckObj['shipmentReference']), (0, _toConsumableArray2.default)(res['vehicles'].shipmentReference))
                  });
                } else {
                  truck = res['vehicles'];
                }

                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(res['orders'])).filter(function (order) {
                  return !_this24.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');

                if (isNewPlanId) {
                  plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                }

                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                }); // Called the update the truck ETA to prevent overlapped orders

                /*if (truck.planId.length > 0) {
                const calculateEta = await this.calculateETA({
                startTime: null,
                index: 0
                });
                if (calculateEta) {
                this.updateCurrentTruck(calculateEta);
                }
                }*/

                _context15.next = 32;
                return this.updateOrderTable(res['orderIds'], res['invalidOrderIds'], res['selectedOrderIds']);

              case 32:
                this.logger.info('Update Truck: ', truck, 'Plan: ', plan);
                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 34:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function handleExistingTruckObj(_x15) {
        return _handleExistingTruckObj.apply(this, arguments);
      }

      return handleExistingTruckObj;
    }()
  }, {
    key: "handleAssignedTruckObj",
    value: function () {
      var _handleAssignedTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(args) {
        var _this25 = this;

        var planId, startTime, truckId, unassignedOrders, currentData, driverId, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan, nTruckIndex, nRoutes, fNRoutes, driverCode, assignedDriverPayload, assignDriverResponse, isAssignSuccessful, truckIndex;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                currentData = args.currentData || {};
                driverId = '';
                _context16.next = 8;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders,
                  isTransfer: false
                });

              case 8:
                res = _context16.sent;

                if (!this.helper.isUndefined(res)) {
                  _context16.next = 11;
                  break;
                }

                return _context16.abrupt("return");

              case 11:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context16.next = 14;
                  break;
                }

                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 14:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this25.helper.includes(res.invalidOrderIds, order.id);
                }), 'id'); // selected truck has one plan id

                if (currentData['routeCount'] === currentData['routePlanIdCount']) {
                  if (plan.truckId && plan.truckId.length >= 1) {
                    plan.truckId = [].concat((0, _toConsumableArray2.default)(plan.truckId), [truckId]).filter(function (tData) {
                      return tData !== currentData['truckId'];
                    });
                  } else {
                    plan.truckId = [truckId];
                  }

                  if (plan.planId && plan.planId.length >= 1) {
                    plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]).filter(function (pData) {
                      return pData !== currentData['planId'];
                    });
                  } else {
                    plan.planId = [planId];
                  }

                  plan.trucks = plan.trucks.filter(function (tData) {
                    return tData['truckId'] !== currentData['truckId'];
                  });
                  plan.trucks.push(truck);
                } else {
                  if (plan.truckId && plan.truckId.length >= 1) {
                    plan.truckId = [].concat((0, _toConsumableArray2.default)(plan.truckId), [truckId]);
                  } else {
                    plan.truckId = [truckId];
                  }

                  if (plan.planId && plan.planId.length >= 1) {
                    plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                  } else {
                    plan.planId = [planId];
                  }

                  nTruckIndex = this.helper.findIndex(plan.trucks, function (tData) {
                    return tData['truckId'] === currentData['truckId'];
                  });
                  nRoutes = plan.trucks[nTruckIndex];
                  fNRoutes = nRoutes.routes.filter(function (r) {
                    return r['planId'] !== currentData['planId'];
                  });
                  plan.trucks[nTruckIndex].driverId = this.helper.uniq(fNRoutes.map(function (r) {
                    return r['driverId'];
                  }));
                  nRoutes.estimatedDistance = this.helper.sumBy(fNRoutes, 'distance');
                  nRoutes.estimatedTime = this.helper.sumBy(fNRoutes, 'time');
                  nRoutes.orderId = nRoutes.orderId.filter(function (o) {
                    return !orderIds.includes(o);
                  });
                  nRoutes.shipmentReference = nRoutes.shipmentReference.filter(function (o) {
                    return !currentData['shipmentReference'].includes(o);
                  });
                  nRoutes.planId = nRoutes.planId.filter(function (i) {
                    return i !== currentData['planId'];
                  });
                  nRoutes.routes = fNRoutes;
                  plan.trucks[nTruckIndex] = nRoutes;
                  plan.trucks.push(truck);
                }

                driverCode = this.getCarPlateFromDriverId(driverId);
                assignedDriverPayload = [];
                unassignedOrders.forEach(function (uOData) {
                  assignedDriverPayload.push({
                    shipref: uOData['shipmentReference'],
                    drivercode: driverCode,
                    truckrecid: truckId
                  });
                });

                if (!(assignedDriverPayload.length >= 1)) {
                  _context16.next = 36;
                  break;
                }

                _context16.next = 24;
                return this.assignDriver(assignedDriverPayload);

              case 24:
                assignDriverResponse = _context16.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];

                if (!isAssignSuccessful) {
                  _context16.next = 33;
                  break;
                }

                truckIndex = this.helper.findIndex(plan.trucks, function (tData) {
                  return tData['truckId'] === truckId;
                });
                plan['trucks'][truckIndex]['routes'].forEach(function (tRoute) {
                  if (tRoute['planId'] === planId) {
                    tRoute['status'] = 'assigned';
                  }
                });
                _context16.next = 31;
                return this.savePlan(plan);

              case 31:
                _context16.next = 34;
                break;

              case 33:
                this.$setPlan({
                  plan: plan
                });

              case 34:
                _context16.next = 37;
                break;

              case 36:
                this.$setPlan({
                  plan: plan
                });

              case 37:
                _context16.next = 39;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 39:
                this.logger.info('Init Truck: ', truck, 'Plan: ', plan);
                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 41:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function handleAssignedTruckObj(_x16) {
        return _handleAssignedTruckObj.apply(this, arguments);
      }

      return handleAssignedTruckObj;
    }()
  }, {
    key: "handleAdhocV2NewTruckObj",
    value: function () {
      var _handleAdhocV2NewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(args) {
        var _this26 = this;

        var planId, startTime, truckId, unassignedOrders, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                _context17.next = 6;
                return this.adHocV2NewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context17.sent;

                if (!this.helper.isUndefined(res)) {
                  _context17.next = 9;
                  break;
                }

                return _context17.abrupt("return");

              case 9:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context17.next = 12;
                  break;
                }

                return _context17.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 12:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this26.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(plan.planId), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context17.next = 20;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 20:
                this.logger.info('Init Truck with completed order(s): ', truck, 'Plan: ', plan);
                return _context17.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 22:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleAdhocV2NewTruckObj(_x17) {
        return _handleAdhocV2NewTruckObj.apply(this, arguments);
      }

      return handleAdhocV2NewTruckObj;
    }()
  }, {
    key: "handleAdhocV2ExistingTruckObj",
    value: function () {
      var _handleAdhocV2ExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(args) {
        var _this27 = this;

        var planId, truckObj, unassignedOrders, truckIndex, res, isShowFailedOrders, failedOrders, truck, plan, firstRouteStatus, isAssignDriver, payload, orderIds, orderShipRefs, currentDriver, carPlate;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                planId = args.planId;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                _context18.next = 6;
                return this.adHocV2ExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context18.sent;

                if (!this.helper.isUndefined(res)) {
                  _context18.next = 9;
                  break;
                }

                return _context18.abrupt("return");

              case 9:
                isShowFailedOrders = res.isShowFailedOrders;
                failedOrders = res.failedOrders;

                if (!(this.helper.isUndefined(res['vehicles']) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context18.next = 13;
                  break;
                }

                return _context18.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 13:
                truck = res['truck'];
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(res['orders'])).filter(function (order) {
                  return !_this27.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');
                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                });
                /**
                 * Assume auto assign to the driver
                 * If not move this to savePlan
                 * */

                firstRouteStatus = this.helper.get(truck, 'routes.0.status', 'unassigned');
                isAssignDriver = firstRouteStatus === 'assigned' && !isShowFailedOrders && failedOrders.length === 0;
                payload = [];

                if (!isAssignDriver) {
                  _context18.next = 29;
                  break;
                }

                orderIds = this.helper.get(truck, 'orderId', []);
                orderShipRefs = this.getShipRefsFromOrderId(orderIds);
                currentDriver = this.helper.get(truck, 'routes.0.driverId', 'unassigned');
                carPlate = this.getCarPlateFromDriverId(currentDriver);

                if (!(this.helper.isUndefined(carPlate) || orderShipRefs.length === 0)) {
                  _context18.next = 28;
                  break;
                }

                return _context18.abrupt("return");

              case 28:
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

              case 29:
                _context18.next = 31;
                return this.updateOrderTable(res['orderIds'], res['invalidOrderIds'], res['selectedOrderIds']);

              case 31:
                this.logger.info('Update Truck with completed orders: ', truck, 'Plan: ', plan);
                return _context18.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  isAssignDriver: isAssignDriver,
                  assignDriverPayload: payload
                });

              case 33:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function handleAdhocV2ExistingTruckObj(_x18) {
        return _handleAdhocV2ExistingTruckObj.apply(this, arguments);
      }

      return handleAdhocV2ExistingTruckObj;
    }()
  }, {
    key: "updateOrderTable",
    value: function () {
      var _updateOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(orderIds, invalidOrderIds, selectedOrderIds) {
        var _this28 = this;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                this.$selectedOrders = [];
                this.$excludedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$excludedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return !_this28.helper.includes(invalidOrderIds, oId);
                })))); // this.$includedOrders = this.$includedOrders.filter(order => this.helper.includes(this.$excludedOrders, order['id']));

                /*this.$includedOrders = this.helper.uniq([
                ...this.$includedOrders,
                ...orderIds.filter(oId => this.helper.includes(invalidOrderIds, oId))
                ]);*/

                this.$includedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return _this28.helper.includes(invalidOrderIds, oId);
                }))).filter(function (oId) {
                  return !_this28.helper.includes(selectedOrderIds, oId);
                }));
                _context19.next = 5;
                return this.$getUnassignedOrders();

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function updateOrderTable(_x19, _x20, _x21) {
        return _updateOrderTable.apply(this, arguments);
      }

      return updateOrderTable;
    }()
  }, {
    key: "getRouteDetails",
    value: function getRouteDetails(truckId) {
      var truck = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truckId;
      }), '0', null);

      if (!truck) {
        return {
          estimatedDistance: 0,
          estimatedTravellingTime: 0
        };
      }

      if (truck && truck.routes && truck.routes.length > 0) {
        // const startTime = moment(truck.routes[0].startTime);
        // const endTime = moment(truck.routes[truck.routes.length - 1].endTime);
        return {
          estimatedDistance: this.helper.sumBy(truck.routes, 'distance') || 0,
          estimatedTravellingTime: this.helper.sumBy(truck.routes, 'time') || 0
        };
      }

      return {
        estimatedDistance: 0,
        estimatedTravellingTime: 0
      };
    }
  }, {
    key: "isOrderIdExistInGlobal",
    value: function isOrderIdExistInGlobal(orderId) {
      var _this29 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this29.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalOrderInfo",
    value: function getGlobalOrderInfo(orderId, fieldName) {
      var _this30 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this30.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isTruckIdExistInGlobal",
    value: function isTruckIdExistInGlobal(truckId) {
      var _this31 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this31.$userInformation && _this31.$userInformation.user && o.userId !== _this31.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalTruckInfo",
    value: function getGlobalTruckInfo(truckId, fieldName) {
      var _this32 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this32.$userInformation && _this32.$userInformation.user && o.userId !== _this32.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isPlanSyncWithGlobal",
    value: function isPlanSyncWithGlobal(data) {
      // return data['user'] !== this.$userInformation.user.name;
      return data['userId'] !== this.$socketId;
    }
  }, {
    key: "updatePlanFromSocket",
    value: function () {
      var _updatePlanFromSocket = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(data) {
        var _this33 = this;

        var globalPlan, bufferPlan, myTruck;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.$truckLoading = true;
                globalPlan = data['plan'];

                if (this.isPlanSyncWithGlobal(data)) {
                  _context20.next = 5;
                  break;
                }

                this.$truckLoading = false;
                return _context20.abrupt("return");

              case 5:
                if (!(this.$plan.trucks.length > 0 && (globalPlan === null || globalPlan.orders.length === 0))) {
                  _context20.next = 13;
                  break;
                }

                this.$setPlan({
                  isReset: true
                });
                this.$resetPlan();
                this.$isPlanExists = false;
                _context20.next = 11;
                return this.$getUnassignedOrders();

              case 11:
                this.$truckLoading = false;
                return _context20.abrupt("return");

              case 13:
                if (this.$selectedTruck && this.$plan.trucks.length > 0) {
                  myTruck = this.currPlanTruck;
                  bufferPlan = _objectSpread(_objectSpread({}, this.helper.cloneDeep(this.$plan)), globalPlan);
                  bufferPlan['trucks'] = [myTruck].concat((0, _toConsumableArray2.default)(globalPlan['data'].filter(function (t) {
                    return t.truckId !== _this33.$selectedTruck;
                  })));
                  bufferPlan['truckId'] = bufferPlan.trucks.map(function (t) {
                    return t.truckId;
                  });
                  bufferPlan['orders'] = this.helper.uniq([].concat((0, _toConsumableArray2.default)(bufferPlan['orders']), (0, _toConsumableArray2.default)(globalPlan['orders'])), 'id');
                  bufferPlan['orderId'] = bufferPlan['orders'].map(function (o) {
                    return o.id;
                  });
                  bufferPlan['planId'] = [].concat((0, _toConsumableArray2.default)(bufferPlan['planId']), (0, _toConsumableArray2.default)(globalPlan['planId']));
                  delete bufferPlan['data'];
                } else {
                  bufferPlan = _objectSpread({
                    code: this.$planDate,
                    planDate: this.$planDate,
                    planId: [],
                    orders: [],
                    trucks: [],
                    orderId: []
                  }, this.helper.cloneDeep(globalPlan));
                  bufferPlan['trucks'] = this.helper.get(bufferPlan, 'data', []);
                  delete bufferPlan['data'];
                }

                this.$setPlan({
                  plan: bufferPlan
                });
                this.$isPlanExists = true;
                _context20.next = 18;
                return this.$getUnassignedOrders();

              case 18:
                this.$truckLoading = false;

              case 19:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updatePlanFromSocket(_x22) {
        return _updatePlanFromSocket.apply(this, arguments);
      }

      return updatePlanFromSocket;
    }()
  }, {
    key: "getAvailableVehicles",
    value: function getAvailableVehicles() {
      var _this34 = this;

      var vehileData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var finalVehicle = [];
      vehileData.forEach(function (vData) {
        var currentTruck = _this34.$plan.trucks.find(function (t) {
          return t['truckId'] === vData['code'];
        });

        if (currentTruck && currentTruck['routes'].length >= 1) {
          if (!currentTruck['routes'].find(function (ct) {
            return ct['status'] === 'assigned';
          })) {
            vData['orders'] = _this34.getCleanOrders(currentTruck['orderId'] || [], _this34.$plan.orders);
            finalVehicle.push(vData);
          }
        } else {
          vData['orders'] = [];
          finalVehicle.push(vData);
        }
      });
      return finalVehicle;
    }
  }, {
    key: "getCleanOrders",
    value: function getCleanOrders() {
      var orderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (orderId.length >= 1 && orders.length >= 1) {
        return orders.filter(function (oData) {
          return orderId.includes(Number(oData['id']));
        });
      }

      return [];
    }
  }, {
    key: "getRouteNumbers",
    value: function getRouteNumbers(routes) {
      var routeNumber = {
        capacity1: 0,
        capacity2: 0,
        // time: Number(routes[routes.length - 1]['endRunningTime'] || 0) + 3600,
        time: 1800,
        routeCount: routes.length
      };
      routes.forEach(function (rData) {
        routeNumber['capacity1'] = routeNumber['capacity1'] + Number(rData['capacity1'] || 0);
        routeNumber['capacity2'] = routeNumber['capacity2'] + Number(rData['capacity2'] || 0);
        routeNumber['time'] = routeNumber['time'] + Number(rData['time'] || 0) + Number(rData['handlingTime'] || 0) + Number(rData['waitingTime'] || 0);
      });
      return routeNumber;
    }
  }]);
  return LastMileDeliveryMixin;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _userLogs.UserLogsMixin));

exports.LastMileDeliveryMixin = LastMileDeliveryMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfCustKey', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfCustKey", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfAPIToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfAPIToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('drivers', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$drivers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('plan', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$plan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultPagination', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$defaultPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('startDate', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$startDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('endDate', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$endDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultOrderColumns', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$defaultOrderColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('tableLoading', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$tableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('orderLocationLists', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$orderLocationLists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultLocationType', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$defaultLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SOCKET_ID', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setSocketId", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TO_BE_UNASSIGNED_ORDER_IDS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setToBeUnassignedOrderIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setPlanDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DATE_RANGE_OPTION', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setDateRangeOption", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TABLE_LOADING', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setTableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_EXCLUDED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setExcludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_INCLUDED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setIncludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_DRIVER', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSelectedDriver", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCK', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSelectedTruck", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_LOADING', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setTruckLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCKS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_BUFFER_TRUCKS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setBufferTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ANY_CHANGES', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setAnyChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_EXISTS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setPlanExists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PAGINATION', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_FILTERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setOrderFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_COLUMNS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSelectedColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_FILTERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setTruckFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_UNASSIGNED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_LOCATION_TYPE', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_LOCATION', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSelectedLocation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SEARCH_TYPE', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setSearchType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MANUAL_ASSIGN_LOADING', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setIsManualAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_AUTO_ASSIGN_LOADING', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setIsAutoAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ASSIGNED_DRIVER_CHANGES', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setIsAssignedDriverChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_FAILED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setFailedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_COLUMN_TEMPLATES', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setOrderColumnTemplates", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_ACTIVE_USERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setGlobalActiveUsers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_ORDERS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_TRUCKS', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$resetPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('initPlan', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$initPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setPlan', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getUnassignedOrders', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$getUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setDateRange', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$setDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('deletePlan', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$deletePlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getTrucks', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$getTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getOrderLocationLists', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$getOrderLocationLists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('planInitOrderIds', {
  namespace: 'lastMileDelivery'
})], LastMileDeliveryMixin.prototype, "$planInitOrderIds", void 0);
exports.LastMileDeliveryMixin = LastMileDeliveryMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], LastMileDeliveryMixin);